import { Box, Flex, Loader } from '@mantine/core';
import { LoginForm } from '@shared/ui';
import { AuthForm } from '@features/auth';
import { useAuth, useShowMe } from '@entities/auth';

export const AuthPage = () => {
  const { isLoading: isLoadingShowMe } = useShowMe();
  const { isAuthenticated } = useAuth();

  if (isLoadingShowMe || isAuthenticated) {
    return (
      <Flex justify='center' w='100%'>
        <Loader size='lg' />
      </Flex>
    );
  }

  return (
    <LoginForm
      title='Войти в личный кабинет администратора'
      description='Введите Email и пароль для входа в личный кабинет'
    >
      <Box pt='2rem'>
        <AuthForm />
      </Box>
    </LoginForm>
  );
};
